"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adjustmentSiloTypes = void 0;
exports.adjustmentSiloTypes = {
    SET_LOADING: 'ADJUSTMENT SILO TYPES SET LOADING',
    SET_ERROR: 'ADJUSTMENT SILO TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'ADJUSTMENT SILO TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'ADJUSTMENT SILO TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'ADJUSTMENT SILO TYPES ON SORT CHANGE',
    ON_MUTATION_CLICK: 'ADJUSTMENT SILO TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'ADJUSTMENT SILO TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'ADJUSTMENT SILO TYPES ON SAVE DATAITEM',
    ON_DELETE_REASON: 'ADJUSTMENT SILO TYPES ON DELETE REASON',
    ON_CHANGE_DATAITEM: 'ADJUSTMENT SILO TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'ADJUSTMENT SILO TYPES SET SUCCESS MODAL',
    SET_DATA_GRID_VESSEL: 'ADJUSTMENT SILO TYPES GET DATA GRID VESSEL',
    SET_LAST_SUCCEED_UPLOAD: 'ADJUSTMENT SILO TYPES SET LAST SUCCEED UPLOAD',
    SET_DATA_GRID_HISTORY: 'ADJUSTMENT STOCKPILE HISTORY TYPES GET DATA GRID',
    ON_PAGE_CHANGE_HISTORY: 'ADJUSTMENT STOCKPILE HISTORY TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE_HISTORY: 'ADJUSTMENT STOCKPILE HISTORY TYPES ON SORT CHANGE',
    SET_DATA_GRID_DELETED_LIST: 'ADJUSTMENT SILO TYPES GET DATA GRID DELETED LIST',
    ON_FILTER_CHANGE_HISTORY: 'ADJUSTMENT STOCKPILE HISTORY TYPES ON FILTER CHANGE',
    ON_SORT_CHANGE_DELETED_LIST: 'ADJUSTMENT SILO TYPES ON SORT CHANGE DELETED LIST',
    ON_PAGE_CHANGE_DELETED_LIST: 'ADJUSTMENT SILO TYPES ON PAGE CHANGE DELETED LIST',
    ON_FILTER_CHANGE_DELETED_LIST: 'ADJUSTMENT SILO TYPES ON FILTER CHANGE DELETED LIST',
    ON_DATE_CHANGE: 'ADJUSTMENT SILO TYPES ON DATE CHANGE',
    SET_EXPORT_DOCUMENTS_URL: 'ADJUSTMENT SILO TYPES SET EXPORT DOCUMENTS URL',
    CLEAR_EXPORT_DOCUMENTS_URL: 'ADJUSTMENT SILO TYPES CLEAR EXPORT DOCUMENTS URL',
    ON_MODIFY_TICKET_SILO: 'ADJUSTMENT SILO TYPES ON MODIFY TICKET SILO',
    SET_DROPDOWN_CONTRACTOR: 'ADJUSTMENT SILO TYPES SET DATA DROPDOWN CONTRACTOR',
    SET_DROPDOWN_BRAND: 'ADJUSTMENT SILO TYPES SET DATA DROPDOWN BRAND',
    SET_DROPDOWN_DRIVER: 'ADJUSTMENT SILO TYPES SET DATA DROPDOWN DRIVER',
    SET_DROPDOWN_VESSEL: 'ADJUSTMENT SILO TYPES SET DATA DROPDOWN VESSEL',
    SET_DROPDOWN_SILO: 'ADJUSTMENT SILO TYPES SET DATA DROPDOWN SILO',
    SET_DROPDOWN_HAULER: 'ADJUSTMENT SILO TYPES SET DATA DROPDOWN HAULER',
    ON_CHECK_FILTER: 'ADJUSTMENT SILO TYPES SET FILTER CHECK',
    ON_SAVE_DATAITEM_CORRECTION: 'ADJUSTMENT SILO TYPES SET DATA GRID VESSEL'
};
